export default class ProductMixes {
  constructor(http) {
    this.http = http;
  }

  pathProductMixes(shopId, panachagesId) {
    return `/api/magasins/${shopId}/panachages/${panachagesId}`
  }

  async productMixes(shopId, link) {
    // linkcontient l'url de panachages
    const productMixesId = link.substr(link.lastIndexOf("/") + 1, link.length);
    const response = await this.http.get(this.pathProductMixes(shopId, productMixesId));
    return response.data;
  }
}
